import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private notificationSubject = new Subject<{
    type: 'success' | 'error' | 'info';
    message: string;
  }>();

  // Observable para que los componentes se suscriban
  notifications$ = this.notificationSubject.asObservable();

  // Método para emitir una nueva notificación
  addNotification(type: 'success' | 'error' | 'info', message: string): void {
    this.notificationSubject.next({ type, message });
  }
}
